/**
 * 任务管理
 * **/

const taskApi = {
  //获取列表
  getList: '/TaskLog/GetList',
}

export default taskApi
